import * as React from 'react';

function Information(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0)" fillRule="evenodd" clipRule="evenodd" fill="#1F1F1F">
        <path d="M2 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12zm10 9.167c-5.055 0-9.167-4.112-9.167-9.167S6.945 2.833 12 2.833 21.167 6.945 21.167 12 17.055 21.167 12 21.167z" />
        <path d="M11.375 10h1.25v5.833h-1.25V10zM11.375 7.398h1.25v1.25h-1.25v-1.25z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Information;
